import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import labels from "../../../constants/displayFields";
import GroupedAssetTableSkeleton from "./GroupedAssetTableSkeleton";
import AssetDetailsModal from "../../../views/inventory/requests/asset-details/AssetDetailsModal";

const styles = {
  tableContainer: {
    maxHeight: "calc(70vh - 120px)",
    overflow: "auto",
  },
};

export default function GroupedAssetTable({
  collection,
  projectId,
  initialLoading,
  loading,
  hasNextPage,
  onScroll,
}) {
  return (
    <TableContainer component={Paper} elevation={0} sx={styles.tableContainer} onScroll={onScroll}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell align="center">{labels.sku_number}</TableCell>
            <TableCell align="center">Associated Item IDs</TableCell>
            <TableCell align="center">Description</TableCell>
            <TableCell align="center">Total Available Quantity</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {initialLoading && collection.length === 0 && <GroupedAssetTableSkeleton count={8} />}
          {collection.map((asset, index) => (
            <TableRow key={`${asset.skuNumber}-${index}`} hover>
              <TableCell align="center">{asset.skuNumber}</TableCell>
              <TableCell align="center">
                {asset.associatedItemIds && asset.associatedItemIds.length > 0
                  ? asset.associatedItemIds.map((itemId, idx) => (
                      <div key={idx}>
                        <AssetDetailsModal
                          asset={{
                            id: asset.associatedAssetIds[idx],
                            itemId: itemId,
                            project: { id: projectId },
                          }}
                        />
                      </div>
                    ))
                  : "—"}
              </TableCell>
              <TableCell align="center">{asset.description}</TableCell>
              <TableCell align="center">{asset.availableQuantity}</TableCell>
            </TableRow>
          ))}
          {loading && hasNextPage && <GroupedAssetTableSkeleton count={3} />}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

